import React, { useRef, useState } from 'react';

import { IcDeleteIcon, IcMoreVerticalIcon } from '@gem/icons';
import { IcGoogleCalendar24Icon } from '@gem/icons/apps';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, Popover } from '@gem/ui-kit';

import { useEmailItemPresenter } from './EmailItem.presenter';
import styles from './EmailItem.styles.m.css';

interface IEmailItemProps {
  email: string;
  isActive: boolean;
}

export const EmailItem: React.FC<IEmailItemProps> = ({ email, isActive }) => {
  const [isOpen, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const { t } = useTranslation();
  const presenter = useEmailItemPresenter();

  const onOpen = (): void => {
    setOpen((prev) => !prev);
  };

  const onDisconnect = (): void => {
    onOpen();
    presenter.onDisconnect(email);
  };

  return (
    <>
      <div className={styles.container}>
        <IcGoogleCalendar24Icon className={styles.googleIcon} />
        <div className={styles.content}>
          <div className={styles.email}>{email}</div>
          <div className={styles.status}>
            {isActive ? t('calendar_settings_connected') : t('calendar_settings_disconnected ')}
          </div>
        </div>
        <IconButton
          Icon={IcMoreVerticalIcon}
          onClick={onOpen}
          theme="15"
          setRef={anchorRef}
          dataTest="calendar-email-actions-more-button"
        />
      </div>
      <Popover
        isOpened={isOpen}
        onClose={onOpen}
        reference={anchorRef.current}
        placement="bottom-end"
        className={styles.popover}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 0] },
          },
        ]}
      >
        <div
          className={styles.disconnect}
          onClick={onDisconnect}
        >
          <IcDeleteIcon className={styles.deleteIcon} />
          <div>{t('calendar_disconnect')}</div>
        </div>
      </Popover>
    </>
  );
};
